export const isCidadaoVulneravelAlimentar = (dataRegistro?: string | null): boolean => Boolean(dataRegistro)
